import { useTaskReport } from "../../Hooks/Features/ProjectDashboard/useTaskReport"
import { SkeletonContainer } from "../Loader/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Calendar } from "primereact/calendar";


const TaskReport = () => {
    const { reportData, loader, colorMap, filter, setFilter, changeMonth } = useTaskReport();

    return (
        <div className="w100 my-2 card-container" >
            <div className="d-flex gap-2 justify-content-between mt-0">
                <span style={{ fontSize: "14px", fontWeight: "600" }}>Report Summary</span>
                <div className='d-flex justify-content-center align-items-center w30'>
                    <FontAwesomeIcon
                        icon="fa-solid fa-backward-step"
                        onClick={() => changeMonth(-1)}
                        style={{ cursor: "pointer" }}
                    />
                    <Calendar
                        value={filter.month}
                        onChange={(e) => setFilter({ month: e.value, isChange: true })}
                        view="month"
                        dateFormat="mm/yy"
                    />
                    <FontAwesomeIcon
                        icon="fa-solid fa-forward-step"
                        onClick={() => changeMonth(1)}
                        style={{ cursor: "pointer" }}
                    />
                </div>

            </div>
            <div className="row">
                {
                    loader ? Object.entries(colorMap).map(([], index) => {
                        return <div className="col-md-6 col-12 my-2" style={{ height: "80px" }} key={index}><SkeletonContainer /></div>
                    }) : reportData?.length > 0 && reportData?.map((value, index) => {
                        return (
                            <div className="col-md-6 col-12 my-2 text-center" key={index}>
                                <div className="task-card-container" style={{ width: "100%", borderTop: `5px solid ${value?.color}` }}>
                                    <span style={{ fontSize: "16px", fontWeight: "500" }}>{value?.name}</span>
                                    <h3 style={{ fontWeight: "700" }}>{value?.value || 0}</h3>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default TaskReport